import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import messages from './langs'
import { getLang } from '@/utils/storage'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.i18nLanguage || getLang() || 'en',
  messages,
})
locale.i18n((key, value) => i18n.t(key, value))

// getLang()=='en'?(document.title = 'Chinaccelerator'):(document.title = 'Chinaccelerator')

export default i18n
